<form [formGroup]="Form">
    <div class="form-row">
        <div class="form-group col-lg-12">
            <textarea rows="3" class="form-control" formControlName="coquhe_tx_description"
                placeholder="Ingrese su pregunta"></textarea>
        </div>
    </div>
    
     
    <br>
    
    <button class="btn btn-badminton btn-sm pull-right" (click)="SaveQuizHeader()">Guardar</button>
</form>
